'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _utils.getLog)('[WSSI]');

var winresServiceSelectItem = function () {
    function winresServiceSelectItem($scope) {
        _classCallCheck(this, winresServiceSelectItem);

        this.$scope = $scope;
    }

    _createClass(winresServiceSelectItem, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.value = false;
            this.ngModelCtrl.$render = function () {
                return _this.render(_this.ngModelCtrl.$viewValue);
            };
            this.ngModelCtrl.$isEmpty = function (value) {
                return !value;
            };
        }
    }, {
        key: 'render',
        value: function render(value) {
            this.value = value;
        }
    }, {
        key: 'read',
        value: function read() {
            this.ngModelCtrl.$setViewValue(this.value);
        }
    }, {
        key: 'isDisabled',
        value: function isDisabled() {
            return this.disabled !== undefined && this.disabled !== false;
        }
    }]);

    return winresServiceSelectItem;
}();

winresServiceSelectItem.$inject = ['$scope'];

_module3.default.component('winresServiceSelectItem', {
    template: require('./winresServiceSelectItem.html'),
    controller: winresServiceSelectItem,
    require: {
        ngModelCtrl: 'ngModel'
    },
    bindings: {
        // An item of the following form:
        // { name: 'John Smith', priceLabel: 'adult', price: 2.5 }
        item: '<',

        // True or false.
        ngModel: '<',

        // If this attribute is set (to anything), the component is disabled.
        disabled: '@',

        // True if the component should show a radio button rather than a checkbox.
        radio: '<'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresServiceSelectItem/winresServiceSelectItem.js
// module id = 465
// module chunks = 2